import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { ChartOptions } from 'libs/portal/src/models/ChartOptions';
// import { ChartOptions } from 'libs/portal/src/models/ChartOptions';
import { Filter } from 'libs/portal/src/models/Filter';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { Endpoints } from '@huge-monorepo/portal/config';
// import { GraphConfig, GraphDataset } from 'libs/portal/src/models/Graph';
// import { FormatDateTimePipe } from 'libs/portal/src/pipes/format-date-time/format-date-time.pipe';

@Component({
  selector: 'app-device-jitter-graph',
  templateUrl: './device-jitter-graph.component.html',
  styleUrls: ['./device-jitter-graph.component.scss'],
})
export class DeviceJitterGraphComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  @Input() IDs: number[];

  graphFilterData: Object = {
    StartDate: this.tools.FormatStartDate(new Date(new Date().getDate() - 1).toISOString()),
    EndDate: this.tools.FormatEndDate(new Date().toISOString()),
    TimePeriod: '2',
  };
  TimeFilters: Filter[];
  selectedInterval: Filter;
  graphLoaded = false;
  loading = true;

  sidenavObservable: Subscription;

  constructor(
    private genericService: GenericService,
    private tools: ToolsService,
    // private dateParsePipe: FormatDateTimePipe,
    private endpoints: Endpoints,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'line',
        height: 350,
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ['#77B6EA'],
      stroke: {
        curve: 'stepline',
      },
      dataLabels: {
        enabled: true,
      },
      title: {
        text: 'Router Jitter',
        align: 'center',
      },
      markers: {
        size: 1,
        hover: {
          sizeOffset: 4,
        },
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Time',
        },
      },
      yaxis: {
        title: {
          text: 'Jitter (ms)',
        },
        min: 0,
        // max: 500
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
    };

    this.tools.GetTimeFilters().subscribe((filters) => {
      // console.log(filters);
      this.TimeFilters = filters;
      this.selectedInterval = this.TimeFilters[3];
      setTimeout(() => {
        this.getJitterGraphData();
      }, 500);
    });

    this.sidenavObservable = this.navigationService.GetSideNav(() => {
      if (this.graphLoaded != false) {
        const temp = this.graphLoaded;
        this.graphLoaded = false;
        setTimeout(() => {
          this.graphLoaded = temp;
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sidenavObservable != null) {
      this.sidenavObservable.unsubscribe();
    }
  }

  buildGraphQueryObject() {
    const timePeriod = parseInt(this.graphFilterData['TimePeriod']);
    return {
      DeviceIDs: this.IDs == null ? [] : this.IDs,
      AllDevices: this.IDs == null ? true : false,
      StartDate: this.graphFilterData['StartDate'],
      EndDate: this.graphFilterData['EndDate'],
      Interval: this.selectedInterval.name,
      TimePeriod: timePeriod > 0 ? timePeriod : null,
    };
  }

  updateSelectedTimeFilter(eve) {
    // console.log("TimeFilter changed: ", eve);
    this.selectedInterval = eve;
    this.refreshGraph();
  }

  updateStart(newDate: string) {
    console.log(newDate);
    this.graphFilterData['StartDate'] = newDate;
  }

  updateEnd(newDate: string) {
    console.log(newDate);
    this.graphFilterData['EndDate'] = newDate;
  }

  getJitterGraphData() {
    const obj = this.buildGraphQueryObject();
    console.log(obj);
    this.genericService.POST(this.endpoints.GET_JITTER_DATA, obj).subscribe(
      (results) => {
        console.log(results);

        if (results['body'] != null) {
          const labels: any = [];
          let count = 0;
          results['body'].forEach((element) => {
            // console.log(element);
            const serie: any = {
              name: element['Device'] != null ? element['Device']['name'] : '-',
              data: [],
            };
            if (element != null && element['Activities'] != null) {
              (element['Activities'] as []).forEach((activity) => {
                if (count == 0) {
                  // let d = this.dateParsePipe.transform(activity["Timestamp"]);
                  const d = this.tools.ParseAPIDateWithTimezone(activity['Timestamp']);
                  labels.push(this.tools.FormatDateTime(d));
                }
                const jitter = Math.ceil(parseFloat(activity['Jitter']) * 1000);
                serie['data'].push(jitter);
              });
            }
            this.chartOptions.series?.push(serie);
            count++;
          });
          this.chartOptions.xaxis.categories = labels;
        }
        this.loading = false;
        this.graphLoaded = true;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  timeFrameSelected() {
    if (parseInt(this.graphFilterData['TimePeriod']) != 0) {
      this.refreshGraph();
    }
  }

  refreshGraph() {
    // console.log("refresh graph");
    this.loading = true;
    this.graphLoaded = false;
    // todo:
    // this.chartOptions.series = [];
    // this.selectedInterval = this.TimeFilters[3];
    setTimeout(() => {
      this.getJitterGraphData();
    }, 500);
  }
}
